import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyleSheet, Text, View } from "react-native";
import { GetWordContainerStyleBySentenceCommand, GetWordStyleBySentenceCommand } from "../../utils/MarkTextHelper";
import Letter from "./Letter";
import { BottomPopExplanationInstance } from "./BottomPopExplanation";
import TranslationText from "./TranslationText"
import * as Helper from "../../utils/Helper";
import _ from "lodash";

class Paragraph extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            curWord: -1,
            curChar: -1,
        };
        this._step = 0;
        this._length = 0;
    }

    componentDidMount() {
        if (this.props.duration > 0) {
            this.setupTimer();
        }
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.step !== nextState.step) {
            return true;
        }

        if (this.state.curWord !== nextState.curWord) {
            return true;
        }

        if (this.state.curChar !== nextState.curChar) {
            return true;
        }

        if (this.props.data !== nextProps.data && (!_.isEqual(this.props.data, nextProps.data))) {
            return true;
        }

        if (this.props.duration !== nextProps.duration) {
            return true;
        }

        if (this.props.progressColor !== nextProps.progressColor) {
            return true;
        }

        if (this.props.onDurationEnd !== nextProps.onDurationEnd) {
            return true;
        }

        if (this.props.disableExplanation !== nextProps.disableExplanation) {
            return true;
        }

        if (this.props.style !== nextProps.style && (!_.isEqual(this.props.style, nextProps.style))) {
            return true;
        }

        if (this.props.specificSentenceStyle !== nextProps.specificSentenceStyle &&
            (!_.isEqual(this.props.specificSentenceStyle, nextProps.specificSentenceStyle)))
        {
            return true;
        }

        if (this.props.letterStyle !== nextProps.letterStyle &&
            (!_.isEqual(this.props.letterStyle, nextProps.letterStyle)))
        {
            return true;
        }

        if (this.props.textStyle !== nextProps.textStyle &&
            (!_.isEqual(this.props.textStyle, nextProps.textStyle)))
        {
            return true;
        }

        if (this.props.textIndent !== nextProps.textIndent) {
            return true;
        }

        if (this.props.charVisible !== nextProps.charVisible) {
            return true;
        }

        if (this.props.pinyinVisible !== nextProps.pinyinVisible) {
            return true;
        }

        if (this.props.translationVisible !== nextProps.translationVisible) {
            return true;
        }

        if (this.props.pinyinStyle !== nextProps.pinyinStyle &&
            (!_.isEqual(this.props.pinyinStyle, nextProps.pinyinStyle)))
        {
            return true;
        }

        if (this.props.translationStyle !== nextProps.translationStyle &&
            (!_.isEqual(this.props.translationStyle, nextProps.translationStyle)))
        {
            return true;
        }

        if (this.props.onLetterPress !== nextProps.onLetterPress) {
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps, prevState) {
        var sentenceChanged = false;
        if (prevProps.data !== this.props.data) {
            const oldSentence = prevProps.data.sentences && prevProps.data.sentences[0];
            const newSentence = this.props.data.sentences && this.props.data.sentences[0];
            sentenceChanged = (oldSentence !== newSentence);
        }

        if (sentenceChanged || prevProps.duration !== this.props.duration) {
            this.clearTimer();
            this._step = 0;
            this._length = 0;
            this.setState({step: 0, curWord: -1, curChar: -1});
            if (this.props.duration > 0) {
                this.setupTimer();
            }
        }
    }

    getWords() {
        if (this.props.data.sentences && this.props.data.sentences[0]) {
            // TODO: support multi sentence?
            if (this.props.data.sentences.length > 1) {
                console.warn('multi sentences have not supported yet!!!');
            }
            return this.props.data.sentences[0].words;
        }
        return null;
    }

    setupTimer() {
        if (this._timer) {
            return;
        }

        const words = this.getWords();
        this._startTime = Date.now();
        if (words && words.length > 0 && this.props.duration > 0) {
            this._length = 0;
            words.map((item, i) => {
                this._length += item.chars.length;
            });
            this._stepms = this.props.duration / this._length;
            this._startTime -= this._stepms;
            this._progress();
            const interval = Math.max(300, this._stepms); // 防止更新过快
            this._timer = setInterval(this._progress, interval);
        }
    }

    clearTimer() {
        if (this._timer) {
            clearInterval(this._timer);
            delete this._timer;
        }

        if (this._endTimer) {
            clearTimeout(this._endTimer);
            delete this._endTimer;
        }
    }

    _progress = () => {
        var curWord = -1;
        var curChar = -1;
        var elapsed = Date.now() - this._startTime;
        var step = parseInt(elapsed / this._stepms);
        if (this._step === step) {
            return;
        }

        this._step = step;
        if (this._step > this._length) {
            this._step = this._length;
        }

        const words = this.getWords();
        if (words) {
            var count = 0;
            for (var i = 0; i < words.length; ++i) {
                var n = words[i].chars.length;
                count += n;
                if (count >= this._step) {
                    curWord = i;
                    curChar = this._step - (count - n);
                    break;
                }
            }
        }

        this.setState({step: this._step, curWord, curChar});
        if (this._step >= this._length) {
            clearInterval(this._timer);
            delete this._timer;
            if (this._endTimer) {
                clearTimeout(this._endTimer);
            }
            this._endTimer = setTimeout(() => {
                delete this._endTimer;
                if (this.props.onDurationEnd) {
                    this.props.onDurationEnd();
                }
            }, 300);
        }
    }

    render() {
        const { sentences } = this.props.data;
        if (sentences.length === 0) return null;

        let textStyle = { ...this.props.textStyle };

        for (var key in this.props.style) {
            if (!(key === "color" || key.indexOf("font") !== -1 || key === "lineHeight")) {
                continue;
            }

            if (!textStyle[key]) {
                textStyle[key] = this.props.style[key];
            }
        }

        // const { sentenceCommand, sentenceCommandSetting } = sentences[0];
        // const sentenceStyle = GetSentenceStyleBySentenceCommand(sentenceCommand, sentenceCommandSetting);

        // Letter 的样式有 marginHorizontal:1 ，所以这里要加2，
        const letterWidth = (textStyle.fontSize || styles.defaultFontSize.fontSize) + 2;

        let translations = "";

        return (
            <>
                <View style={[styles.container, this.props.style,  /* sentenceStyle */]}>
                    {this.props.textIndent ? <View style={{ marginLeft: letterWidth * 2 }} /> : null}
                    {sentences.map((sentence, index) => {
                        const { words, translation } = sentence;
                        translations += Helper.translateChinese(translation, false, this.props.language);

                        let enableLearnedColor = this.props.enableLearnedColor;
                        let specificSentenceStyle = {};
                        let specificTextStyle = {};
                        if (this.props.specificSentenceStyle.index === index) {
                            specificSentenceStyle = { ...this.props.specificSentenceStyle.style }

                            for (var key in specificSentenceStyle) {
                                if (!(key === "color" || key.indexOf("font") !== -1 || key === "lineHeight")) {
                                    continue;
                                }

                                specificTextStyle[key] = specificSentenceStyle[key];
                            }

                            if (this.props.specificSentenceStyle.enableLearnedColor !== undefined) {
                                enableLearnedColor = this.props.specificSentenceStyle.enableLearnedColor;
                            }
                        }

                        return words.map((word, wi) => {
                            const { chars, syllables, command } = word;
                            const wordStyle = GetWordStyleBySentenceCommand(command);
                            const wordContainerStyle = GetWordContainerStyleBySentenceCommand(command);

                            if (this.props.language !== 'zh') {
                                return (<View key={wi} style={[this.props.letterStyle, wordContainerStyle, specificSentenceStyle]}>

                                            <Text key={wi} style={{...wordStyle, ...textStyle, ...specificTextStyle}}>
                                                {this.props.charVisible ? chars.join("") : ""}
                                            </Text>
                                        </View>);
                            }
                            return chars.map((char, i) => {
                                var exstyle = {};
                                if (index === 0 && this.state.curWord >= 0) {
                                    if (wi < this.state.curWord) {
                                        exstyle.color = this.props.progressColor;
                                    }
                                    else if (wi === this.state.curWord && i < this.state.curChar) {
                                        exstyle.color = this.props.progressColor;
                                    }
                                }
                                return (
                                    <View key={i} style={[this.props.letterStyle, wordContainerStyle, specificSentenceStyle]}>
                                        <Letter
                                            style={{ ...wordStyle, ...textStyle, ...specificTextStyle, ...exstyle }}
                                            data={{ char, pinyin: syllables[i], }}
                                            enableLearnedColor={enableLearnedColor}
                                            charVisible={this.props.charVisible}
                                            pinyinVisible={this.props.pinyinVisible}
                                            syllableStyle={this.props.pinyinStyle}
                                            onPress={() => {
                                                if (Helper.isPunctuation(word.chars.join(""))) return;
                                                this.props.onLetterPress && this.props.onLetterPress();
                                                if (!this.props.disableExplanation) {
                                                    if(word.chars.length===1)
                                                    {
                                                        BottomPopExplanationInstance.handleLetterExplanationSheet({char: word.chars[0], pinyin: word.syllables[0]});
                                                    }else{
                                                        BottomPopExplanationInstance.handleWordExplanationSheet(word);
                                                    }
                                                }
                                            }}
                                        />
                                    </View>
                                );
                            })
                        }
                        )
                    })}
                </View>
                {this.props.translationVisible &&
                    <TranslationText style={this.props.translationStyle}>
                        {/*加两个中文宽度的占位符*/}
                        {/* NOTE: Android下Text内嵌View必须设置width和height */}
                        {this.props.textIndent ? <View style={{ width: letterWidth * 2, height: 0 }} /> : null}
                        <Text>{translations}</Text>
                    </TranslationText>
                }
            </>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    defaultFontSize: {
        fontSize: 14
    }
});

Paragraph.propTypes = {
    data: PropTypes.object,
    duration: PropTypes.number,
    progressColor: PropTypes.string,
    onDurationEnd: PropTypes.func,
    disableExplanation: PropTypes.bool,
    enableLearnedColor: PropTypes.bool,
    style: PropTypes.object,
    specificSentenceStyle: PropTypes.object,
    letterStyle: PropTypes.object,
    textStyle: PropTypes.object,
    textIndent: PropTypes.bool,
    charVisible: PropTypes.bool,
    pinyinVisible: PropTypes.bool,
    translationVisible: PropTypes.bool,
    pinyinStyle: PropTypes.object,
    translationStyle: PropTypes.object,
    onLetterPress: PropTypes.func,
};

Paragraph.defaultProps = {
    data: { sentences: [] },
    duration: 0,
    language: 'zh',
    progressColor: '',
    onDurationEnd: null,
    disableExplanation: false,
    enableLearnedColor: true,
    style: {},
    specificSentenceStyle: {},
    letterStyle: {}, // margin, padding, or others
    textStyle: {}, // fontSize, color, lineHeight
    textIndent: false,
    charVisible: true,
    pinyinVisible: true,
    translationVisible: false,
    pinyinStyle: null,
    translationStyle: null,
    onLetterPress: null,
};

export default Paragraph;
